import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useMemo, useState, createContext } from "react";

const NavbarContext = createContext({
  sidebar: { isSidebarOpen: false, setIsSidebarOpen: () => {} },
});

export const NavbarContextProvider = ({ children }) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [isSidebarOpen, setIsSidebarOpen] = useState(!isSmallScreen);

  const sidebar = useMemo(
    () => ({ isSidebarOpen, setIsSidebarOpen }),
    [isSidebarOpen, setIsSidebarOpen]
  );

  const navbarContext = {
    sidebar,
  };

  return (
    <NavbarContext.Provider value={navbarContext}>
      {children}
    </NavbarContext.Provider>
  );
};

export default NavbarContext;
